<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-mountain'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">留学目的</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">留学目的</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getGoalLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>留学の目的</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">目的の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.goals.content">
          <v-chip
            v-for="item in getGoalItems"
            :key="`goals_content_${item.value}`"
            :value="item.value"
            :rules="rules.goals">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.goals.note"
          label="留学目的の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyGoals',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        goals: {
          vocabulary: '語学力の向上',
          skillup: 'スキルアップ/キャリアアップを図る',
          work: '海外で働く',
          degree: '学位/資格の取得',
          travel: '自分探しのため',
          refresh: 'リフレッシュ/心機一転',
          vacation: '休暇を楽しむ',
          others: 'その他'
        }
      },
      form: {
        goals: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        goals: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.goals
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.goals.content && this.$props.data.goals.content === 'NONE'))
        this.$set(this.form, 'goals', {
          id: '' + (this.$props.data.goals.id ? this.$props.data.goals.id : 'new_goals'),
          content: this.$props.data.goals.content ? this.$props.data.goals.content.split(',') : [],
          note: this.$props.data.goals.note ? this.$props.data.goals.note : ''
        })
      } else {
        this.$set(this.form, 'goals', {
          id: 'new_goals',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'goals'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.goals, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['goals', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'goals'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['goals', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'goals'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.goals &&
        this.$props.data.goals.content &&
        this.$props.data.goals.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.goals &&
        this.$props.data.goals.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.goals &&
        this.$props.data.goals.note
      ) ? this.$props.data.goals.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    getGoalItems () {
      return Object.keys(this.meta.goals).map(key => {
        return {
          text: this.meta.goals[key],
          value: key
        }
      })
    },
    getGoalLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.goals &&
        this.$props.data.goals.content
      ) ? this.$props.data.goals.content.split(',').map(key => {
          return (this.meta.goals[key]) ? this.meta.goals[key] : ''
        }) : []
    }
  }
}
</script>
